var App = App || {};
App.Initialization = App.Initialization || {};

App.Initialization['widget.appHighlights'] = (function () {
    'use strict';

    const initialize = (widget) => {
        const featureControls = widget.querySelectorAll(".feature-control");
        const featureImages = widget.querySelectorAll(".feature-img");
        const btnRefresh = widget.querySelector(".btn-refresh");

        featureControls.forEach(button => {
            button.addEventListener("click", function () {
                showImage(button.getAttribute("data-id"));
                btnRefresh.classList.remove("d-none");
            });
            button.addEventListener("focus", function () {
                button.click();
            });
        });

        btnRefresh.addEventListener("click", function () {
            showImage(btnRefresh.getAttribute("data-id"));
            btnRefresh.classList.add("d-none");
            featureControls[0].setAttribute("tabindex", "0");
        });
        btnRefresh.addEventListener("focus", function () {
            if (btnRefresh.matches(':focus-visible')) {
                showImage(btnRefresh.getAttribute("data-id"));
            }
        });

        const showImage = (controlId) => {
            featureImages.forEach(image => {
                image.classList.add("hidden-image");
            });

            widget.querySelector("#FeatureImage-" + controlId).classList.remove("hidden-image");
        }

        function docReady(fn) {
            if (document.readyState === "complete" || document.readyState === "interactive") {
                // call on next available tick
                setTimeout(fn, 1);
            } else {
                document.addEventListener("DOMContentLoaded", fn);
            }
        }

        //Because the hidden refresh button is tab 0, we must explicitly set tab 1's tabindex after bootstrap's setup
        docReady(function () {
            featureControls[0].setAttribute("tabindex", "0");
        });
    }

    return {
        initialize
    };

})();